module.exports = __webpack_public_path__ + "static/savings-44d491f17ab8191c649d38669e8fe63b.svg";